// extracted by mini-css-extract-plugin
export default {"list":"SortsMobile_list__XLVBq","on":"SortsMobile_on__1UvAK","item":"SortsMobile_item__20YfQ"};